export default __webpack_public_path__ + "static/media/warning.4193d932.svg";